module.exports = __webpack_public_path__ + "static/media/shoutout.f61b77b9.png";